import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-602c0edc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-3 lg:py-6 h-100 relative" }
const _hoisted_2 = { class: "flex flex-wrap gap-4" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row relative mt-5" }
const _hoisted_4 = { class: "grow mr-6 w-full" }
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 lg:grid-cols-6 mt-6 gap-4"
}
const _hoisted_6 = { class: "p-6 pb-4 mb-4" }
const _hoisted_7 = { class: "-mx-6 border-b mb-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-20 mb-10 border-t-gray-800" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceDetailTitle = _resolveComponent("ServiceDetailTitle")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ServiceCardContent = _resolveComponent("ServiceCardContent")!
  const _component_GenericCardShell = _resolveComponent("GenericCardShell")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!
  const _component_ServiceDetailReportsAndDashboards = _resolveComponent("ServiceDetailReportsAndDashboards")!
  const _component_ReportGroupHeader = _resolveComponent("ReportGroupHeader")!
  const _component_ServiceReport = _resolveComponent("ServiceReport")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ServiceDetailTitle, {
      error: _ctx.error,
      loading: _ctx.loading,
      title: _ctx.detail.title,
      link: 'analytics'
    }, null, 8, ["error", "loading", "title"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.detail.filters)
        ? (_openBlock(), _createBlock(_component_Filters, {
            key: 0,
            filters: _ctx.detail.filters,
            onFiltersLoading: _ctx.blockFilters
          }, null, 8, ["filters", "onFiltersLoading"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.detail.kpis)
          ? (_openBlock(), _createBlock(_component_ServiceCardContent, {
              key: 0,
              "preview-infos": _ctx.detail.kpis,
              "is-preview": false,
              previewType: 'Kpi',
              fromList: false
            }, null, 8, ["preview-infos"]))
          : _createCommentVNode("", true),
        (_ctx.detail.charts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.charts, (chart, i) => {
                return (_openBlock(), _createBlock(_component_GenericCardShell, {
                  class: _normalizeClass(["h-[460px]", `grid-${chart.size}`]),
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ServiceCardContent, {
                      id: chart.id,
                      title: chart.label,
                      previewType: 'Chart',
                      "preview-infos": chart,
                      fromList: false
                    }, null, 8, ["id", "title", "preview-infos"])
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.detail.dashboards && _ctx.detail.dashboards.length)
          ? (_openBlock(), _createBlock(_component_ServiceDetailReportsAndDashboards, {
              key: 2,
              title: _ctx.$t('serviceDetail.dashboard.title'),
              subtitle: _ctx.$t('serviceDetail.dashboard.subtitle')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.dashboards, (dashboard, i) => {
                  return (_openBlock(), _createBlock(_component_DashboardCard, {
                    key: i,
                    title: dashboard.title,
                    description: dashboard.description,
                    id: dashboard.id
                  }, null, 8, ["title", "description", "id"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["title", "subtitle"]))
          : _createCommentVNode("", true),
        (_ctx.detail.reports && _ctx.detail.reports.length)
          ? (_openBlock(), _createBlock(_component_ServiceDetailReportsAndDashboards, {
              key: 3,
              title: _ctx.$t('serviceDetail.report.title'),
              subtitle: _ctx.$t('serviceDetail.report.subtitle')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.reports, (report, j) => {
                  return (_openBlock(), _createBlock(_component_GenericCardShell, {
                    key: j,
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_ReportGroupHeader, {
                            title: report.title,
                            id: report.id,
                            subtitle: _ctx.analyticsCategory ? `${_ctx.analyticsCategory} | ${_ctx.detail.title}` : `${_ctx.detail.title}`,
                            onRequestUpload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestUpload()))
                          }, null, 8, ["title", "id", "subtitle"])
                        ]),
                        _createVNode(_component_ServiceReport, {
                          id: report.id
                        }, null, 8, ["id"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["title", "subtitle"]))
          : _createCommentVNode("", true),
        _hoisted_8
      ])
    ])
  ]))
}